import React, { FC, ComponentType, ReactNode } from 'react';

import { SCP } from 'ia-react-core/~/interfaces/SCP';

import { StyledMessage, StyledIcon, StyledMessageText, StyledTitle } from './Message.styles';

export interface MessageProps extends SCP<'aside'> {
  /** Custom error message. Alternative to using the `error`prop. */
  children?: ReactNode;
  /** The message title. */
  messageTitle?: string;
  /** The icon component */
  Icon?: ComponentType<any>;
  /** Color of the icon. */
  iconColor?: string;
  /** Force the error to always display vertically. */
  vertical?: boolean;
  /** Css text transform of the title. */
  titleTextTransform?: string;
}

const Message: FC<MessageProps> = ({ children, messageTitle, Icon, iconColor, vertical, titleTextTransform, ...props }) => (
  <StyledMessage
    role="status"
    withIcon={Boolean(Icon)}
    iconColor={iconColor}
    vertical={vertical}
    {...props}
  >
    {Icon && <StyledIcon as={Icon} vertical={vertical} />}
    <StyledMessageText vertical={vertical}>
      {messageTitle && <StyledTitle titleTextTransform={titleTextTransform}>{messageTitle}</StyledTitle>}
      {children}
    </StyledMessageText>
  </StyledMessage>
);

export default Message;
